export const isFreePlan = (value) => {
  return 'CreatorAIFree' === value;
};
